import React, { useState } from "react"
import { useEffect } from "react"

import { getOrderGameUrl } from "../../apis/OrdersAPI"
import styles from "./index.module.scss"
import bannerMobileImage from "./assets/banner-gamindo-mobile.png"
import bannerImage from "./assets/banner-gamindo.png"

// ----------------------------------------------------------------------------

export default function GameCard(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { userId, orderId, userToken } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [gameUrl, setGameUrl] = useState(null)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    init()
  }, [])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  async function init() {
    try {
      let response = await getOrderGameUrl(userId, orderId, userToken)

      let url = response?.body?.result?.url
      if (url) {
        setGameUrl(url)
      }
    } catch(error) {
      setGameUrl(null)
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  if (!gameUrl) return null

  return (
    <div
      className={styles.gameCard}
      onClick={() => {
        window.open(gameUrl, "_blank")
      }}
    >
      <img className={`${styles.gameImage} ${styles.bannerMobile}`} src={bannerMobileImage} />
      <img className={`${styles.gameImage} ${styles.bannerDesktop}`} src={bannerImage} />
    </div>
  )
}

// ----------------------------------------------------------------------------
